import {PromoCode, PromoType} from '@domain/model/PromoCode/PromoCode';

const GetSitePromoCode =
  () =>
  (servicePromo: string): PromoCode | null => {
    return servicePromo ? {value: servicePromo, type: PromoType.SITE} : null;
  };

export {GetSitePromoCode};
